import { useQuery } from '@tanstack/react-query';

import { screenRulesQueryOptions } from './queryOptions';
import type { ScreenRules } from './types';

export const useScreenRules = (): ScreenRules | undefined => useQuery(screenRulesQueryOptions()).data;
